import axios from "@/app/Axios";

class DotacionGeneral{

async index(){
    try {
        const response = await axios.get("/dotacion-general");
        return response.data;

    } catch (error) {         
        console.log(error);  
        console.log(error.response.data);
        const errorData = error.response.data;
        return errorData;
    }
}
    async dotacionprinc() {
        try {
            const response = await axios.get("/dotacionprincipal");
            const data = response.data.data;
            console.log("Datos recuperados:", data); // Agrega esta línea
            return data;
        } catch (error) {
            console.log(error);
            console.log(error.response.data);
            const errorData = error.response.data;
            return errorData;
        }
    }

}//class


export default DotacionGeneral;
